module.exports = __webpack_public_path__ + "static/media/SR300 Copy.b2630a8b.png";